import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { useT } from "@/lib/i18n";

export function NotFoundPage() {
  const { t } = useT();
  return (
    <div className="p-10 text-center">
      <h1 className="mb-2 text-2xl font-bold">404</h1>
      <p className="mb-4 text-muted-foreground">{t("common.not_found")}</p>
      <Button asChild>
        <Link to="/">{t("nav.dashboard")}</Link>
      </Button>
    </div>
  );
}
